const Hamburger = ({ setIsShownNav, isShownNav }) => {
  return (
    <div
      onClick={() => setIsShownNav(!isShownNav)}
      className="z-10 cursor-pointer lg:hidden"
    >
      <svg
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.33331 1H22.6666M1.33331 9H22.6666M13.3333 17H22.6666"
          stroke="#F7F6F2"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default Hamburger;
